import { getFileExtension } from '@com/utils/file'

/**
 * 判断是否是纯 fbx 的模型，即不包含贴图资源
 * @param previewUrl resource 资源的 previewUrl 中会包含模型的所有文件，如果没有贴图资源，则说明是纯 fbx 模型
 */
export function isPureModel(previewUrl: string[]): boolean {
  if (!previewUrl || !previewUrl.length) return false
  return !!(
    previewUrl.length &&
    previewUrl.length === 1 &&
    getFileExtension(String(previewUrl[0])).toLocaleLowerCase() === 'lm'
  )
}

export function getModelLm(previewUrl: string[]): string {
  if (!previewUrl || !previewUrl.length) return ''
  // 贴图资源
  const lmRes = previewUrl.find((url) => {
    return getFileExtension(url).toLocaleLowerCase() === 'lm'
  })
  if (lmRes) {
    return lmRes
  }
  return ''
}

/**
 * 返回贴图资源
 * @param previewUrl resource 资源的 previewUrl 中会包含模型的所有文件，获取非 lm 文件的资源的贴图类型
 */
export function getModelTex(previewUrl: string[]): string {
  if (!previewUrl || !previewUrl.length) return ''
  // 贴图资源
  const texRes = previewUrl.find((url) => {
    const ext = getFileExtension(url).toLocaleLowerCase()
    return ext !== 'lm' && ext !== 'bin' && ext !== 'json'
  })
  if (texRes) {
    return texRes
  }
  return ''
}

/**
 * 返回贴图资源的类型
 * @param previewUrl resource 资源的 previewUrl 中会包含模型的所有文件，获取非 lm 文件的资源的贴图类型
 */
export function getModelTexType(previewUrl: string[]): string {
  return getFileExtension(getModelTex(previewUrl)).toLocaleLowerCase()
}
